<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-configurar-recibos') {
            next({ name: 'des-configurar-recibos-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-configurar-recibos') {
            this.$router.push({ name: 'des-configurar-recibos-list' });
        }
    },
};
</script>
